var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1371_5072)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1371_5072",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 0H0V18H18V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1371_5072)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0781 3.96875V1.45312C10.0781 1.2625 10.0024 1.07969 9.8676 0.94489C9.7328 0.8101 9.55 0.734375 9.3594 0.734375H1.45312C1.2625 0.734375 1.07969 0.8101 0.94489 0.94489C0.8101 1.07969 0.734375 1.2625 0.734375 1.45312V16.5469C0.734375 16.7375 0.8101 16.9203 0.94489 17.0551C1.07969 17.1899 1.2625 17.2656 1.45312 17.2656H9.3594C9.55 17.2656 9.7328 17.1899 9.8676 17.0551C10.0024 16.9203 10.0781 16.7375 10.0781 16.5469V14.0312",
    stroke: "#121212",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2656 9H3.60938",
    stroke: "#121212",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6719 12.5938L17.2656 9L13.6719 5.40625",
    stroke: "#121212",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1371_5072"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignOut);
export default __webpack_public_path__ + "static/media/sign_out.02844f8b8178bfecbe35c0ec095799ba.svg";
export { ForwardRef as ReactComponent };